export default "__VITE_ASSET__DHBGqcHJ__";